export default __webpack_public_path__ + "static/media/Discord-Button.3b70d8e9.svg";